<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M4.27087 15.583H5.52087C5.93527 15.583 6.3327 15.4184 6.62573 15.1254C6.91875 14.8323 7.08337 14.4349 7.08337 14.0205C7.08337 13.6061 6.91875 13.2087 6.62573 12.9157C6.3327 12.6226 5.93527 12.458 5.52087 12.458H4.27087V16.833"
      stroke="#34C759"
      stroke-width="1.42857"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.58337 9.33301V3.70801C4.58337 3.54225 4.64922 3.38328 4.76643 3.26607C4.88364 3.14886 5.04261 3.08301 5.20837 3.08301H12.7084L17.0834 7.45801V9.33301"
      stroke="#34C759"
      stroke-width="1.42857"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.7084 3.08301V7.45801H17.0834"
      stroke="#34C759"
      stroke-width="1.42857"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.0834 14.958H17.7084V16.276C17.5489 16.449 17.3558 16.5877 17.1409 16.6835C16.9259 16.7793 16.6937 16.8302 16.4584 16.833C15.4232 16.833 14.5834 15.8533 14.5834 14.6455C14.5834 13.4377 15.4232 12.458 16.4584 12.458C16.7932 12.459 17.12 12.5611 17.3959 12.751"
      stroke="#34C759"
      stroke-width="1.42857"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.27087 16.833V12.458L12.3959 16.833V12.458"
      stroke="#34C759"
      stroke-width="1.42857"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "FilePngIcon",
};
</script>
